export const useSiteName = () => {
  const meta = document.querySelector('meta[name="site:name"]')

  if (meta) {
    return meta.content
  }
}
